import { useToastContext } from '@sato/components';

import { useDialog } from '@providers/DialogProvider';
import { t } from '@stores/localization';
import { parkingRentingStore } from '@stores/parkingRentingStore/parkingRentingStore';
import { switchParkingSpacesStore } from '@stores/parkingRentingStore/switchParkingSpacesStore';

/** Hook that returns a function to render a dialog where the user can abort ongoing parking renting or changing process. */
export const useAbortRentingDialog = (props?: {
  /** Called after parking renting is successfully aborted. */
  onComplete?: () => void;
  storeType: 'rentNewSpace' | 'switchSpaces';
}) => {
  const { openDialog } = useDialog();

  const toasts = useToastContext();

  const store =
    props?.storeType === 'switchSpaces'
      ? switchParkingSpacesStore
      : parkingRentingStore;

  const openTerminateRentingDialog = () => {
    openDialog({
      heading: t('parking.terminate_renting_confirmation_text'),
      body: t('parking.you_are_terminating_renting'),
      icon: 'clock24',
      actionButton: {
        children: t('parking.continue_renting'),
      },
      backButton: {
        children: t('parking.terminate_renting'),
        onClick: async () => {
          await store.abortRentingAndUnlockProduct().catch((e) => {
            // Catch instead of throw so that store is cleared even if abort failed.
            console.error(
              'Backend gave an error when trying to unlock / cancel product renting',
              e
            );
          });

          store.clear();

          toasts.addToast({
            message: t('parking.abortSuccessfulToastMessage'),
            icon: 'check24',
            variant: 'success',
            duration: 5000,
          });

          props?.onComplete?.();
        },
      },
    });
  };

  return {
    open: openTerminateRentingDialog,
  };
};
